import React from 'react';

import isNil from 'lodash/isNil';

import type { NumberStatusChipProps } from '@packages/fenrir/components';
import { NumberStatusChip } from '@packages/fenrir/components';

export interface RiskScoreStatusChipProps {
  score?: number | null;
}

function getRiskScoreSeverity(
  score: RiskScoreStatusChipProps['score'],
): NumberStatusChipProps['status'] {
  if (!score || score < 0.1 || score > 10) {
    return 'unassigned';
  }

  if (score >= 9) {
    return 'critical';
  }

  if (score >= 7) {
    return 'high';
  }

  if (score >= 4) {
    return 'medium';
  }

  return 'unassigned';
}

export const RiskScoreStatusChip: React.FC<RiskScoreStatusChipProps> = ({
  score,
}) => (
  <NumberStatusChip
    hideIcon
    value={!isNil(score) ? score.toFixed(1) : null}
    status={getRiskScoreSeverity(score)}
  />
);
